// extracted by mini-css-extract-plugin
module.exports = {"configWindow":"invalidMagicLink_configWindow__2WY4W"};